import { SWReactIcons } from "@similarweb/icons";

import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import { PLATFORM_ICON_NAME } from "app/pages/sales-intelligence/modules/company-analysis/constants/digital-assets";

import { StyledAppIconWrapper, StyledAppImg, StyledPlatformBadge } from "./styles";

type Props = {
    icon: string;
    market: AppOperatingSystem;
    href: string;
    onClick?: VoidFunction;
};

const AppIconWithBadge = ({ icon, market, href, onClick }: Props) => {
    return (
        <StyledAppIconWrapper
            data-automation="company-card-app-icon"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            <StyledAppImg
                src={icon}
                alt=""
            />
            <StyledPlatformBadge aria-hidden="true">
                <SWReactIcons
                    iconName={PLATFORM_ICON_NAME[market]}
                    size="xs"
                />
            </StyledPlatformBadge>
        </StyledAppIconWrapper>
    );
};

export default AppIconWithBadge;
